import { MANUAL } from './manual';
import { I18N } from './i18n';
import { mtx } from './manualTopics';
import de from './manualNew/de.json';
import en from './manualNew/en.json';
import it from './manualNew/it.json';
import es from './manualNew/es.json';
import pt from './manualNew/pt.json';
import fr from './manualNew/fr.json';
import sq from './manualNew/sq.json';
import AQ from './aquaManual.json';
import SW from './stormManual.json';
import PMM from './pmManual.json';

// 15-chapter reference manual: o:N = classic chapter, n:key = new section, mn:/mx: = mode sections, mg = mode selection
const NEW = { de, en, it, es, pt, fr, sq };
const Q = (...k) => k.map((x) => `n:${x}`);
const PLAN = [
  [22, '🤝', Q('fo_principle', 'fo_aquaflow', 'fo_workflow')],
  [0, '🚀', Q('quick_install', 'quick_mode', 'quick_project', 'quick_map', 'quick_draw', 'quick_photo', 'quick_pdf', 'quick_sync')],
  [1, '📁', ['o:0', 'n:offline', 'n:pm_archive', 'n:pc_desk']],
  [2, '🗺️', ['o:1', 'n:cadimport', 'o:20']],
  [3, '🔧', ['o:2', 'n:nettopo', 'n:shutoff', 'n:netquality', 'o:17', 'o:19']],
  [4, '🚨', ['o:3', 'n:streetview']],
  [5, '🤖', ['o:4', 'n:leakbuster', 'n:dictation']],
  [6, '📤', ['o:5']],
  [7, '🖥️', ['mg', 'o:6', 'n:drawer', 'o:13']],
  [8, '📷', ['o:7', 'n:photo_dir']],
  [9, '📦', ['o:8', 'n:teampack']],
  [10, '⛏️', ['o:9']],
  [11, '💶', ['o:10']],
  [12, '🎯', ['n:target', 'o:11', 'n:logger_round', 'n:offline_navi']],
  [13, '🛰️', ['o:12', 'n:rtkengine', 'n:stakebull', 'o:15', 'o:16']],
  [14, '🏭', null],
  [15, '🏷️', ['o:21']],
  [16, '🏗️', ['n:mfrcat', 'n:mapprod', 'n:repmat', 'n:siteplan']],
  [17, '📏', Q('meas_overview', 'meas_distance', 'meas_area', 'meas_height', 'meas_profile', 'meas_ar', 'meas_photo', 'meas_facade', 'meas_survey', 'meas_pit', 'meas_accuracy')],
  [18, '✨', Q('leakbuster', 'new_sectors', 'new_tools_by_sector', 'new_open_pipe', 'new_pit_over_pipe', 'new_dealers', 'new_offline_assets', 'new_pc_install', 'new_owner_key', 'new_feature_tree', 'new_tree_poster', 'new_demo_mode', 'new_promo_card', 'new_tours_start', 'new_controls', 'new_worklog', 'new_calib', 'new_timesheet', 'new_3d', 'new_depth_units', 'new_rtk_auto', 'new_field_help', 'logger_round', 'new_logger_plan', 'new_symbols', 'photo_dir', 'sewer_insp', 'inhouse_extra', 'locate_extra', 'survey_extra', 'new_sketch', 'new_moist_areas', 'new_leak_photo', 'new_damage_report', 'new_ar_stake', 'new_photo_branch', 'new_ai_key', 'new_wall_view', 'new_heat', 'new_roof', 'new_backup', 'flyover')],
  [19, '❓', Q('faq_tool_missing', 'faq_pipe_gone', 'faq_gps', 'faq_offline', 'faq_photo', 'faq_pdf', 'faq_license', 'faq_pc', 'faq_dwg', 'faq_backup', 'faq_update', 'faq_storage')],
  [20, '🌊', Q('aquaflow', 'aqua_ref', 'aqua_leakfind', 'aqua_leakreport', 'aqua_hw', 'dripx', 'oss_engines')],
  [21, '🔒', Q('dsgvo')],
  [23, '🌧️', Q('stormwater', 'storm_flood', 'storm_river', 'storm_report', 'stormy')],
];
const R = (p, n) => Array.from({ length: n }, (_, i) => `${p}_${i + 1}`);
const IMGS = {
  net_share: ['net_1', 'net_2', 'net_3'],
  pc_desk: ['pc_1', 'pc_4', 'pc_3'], pm_archive: ['pc_2', 'pm_1', 'pm_2'],
  quick_install: R('q_install', 3), quick_mode: R('q_mode', 2), quick_project: R('q_project', 2), quick_map: R('q_map', 3),
  quick_draw: R('q_draw', 4), quick_photo: R('q_photo', 3), quick_pdf: R('q_pdf', 2), quick_sync: R('q_sync', 2),
  meas_overview: R('m_over', 1), meas_distance: R('m_dist', 3), meas_area: R('m_area', 2), meas_height: R('m_height', 2),
  meas_profile: ['m_prof_2'], meas_ar: R('m_ar', 2), meas_photo: R('m_photo', 2), meas_facade: R('m_facade', 3),
  meas_survey: R('m_survey', 2), meas_pit: R('m_pit', 3), meas_accuracy: R('m_acc', 3),
  water_extra: R('s_water', 4), gas_extra: R('s_gas', 3), cable_extra: R('s_cable', 3), pipe_slope: R('s_pipe', 3),
  garden_extra: R('s_garden', 3), building_scaffold: R('s_building', 3), outdoor_extra: R('s_outdoor', 3),
  prax_water: R('p_water', 2), prax_gas: R('p_gas', 2), prax_cable: R('p_cable', 2), prax_pipe: R('p_pipe', 3),
  prax_garden: R('p_garden', 2), prax_building: R('p_building', 2), prax_outdoor: R('p_outdoor', 2),
  new_feature_tree: R('f_tree', 2), new_tree_poster: ['f_poster_1'], new_demo_mode: R('f_demo', 2), new_promo_card: ['f_promo_1'], new_tours_start: R('f_start', 2),
};
const SUBS = [
  ['water', 'detect_water', ['mn:detect_water', 'o:14', 'n:logger_round', 'n:net_share', 'mx:press', 'n:water_extra', 'n:leak_qty', 'n:prax_water']],
  ['gas', 'detect_gas', ['mn:detect_gas', 'n:gas_extra', 'n:prax_gas']],
  ['cable', 'detect_cable', ['mn:detect_cable', 'n:cable_extra', 'n:prax_cable']],
  ['sewer', 'detect_sewer', ['n:sewer_insp', 'n:pipe_slope', 'n:photo_dir']],
  ['inhouse', 'detect_inhouse', ['n:inhouse_extra', 'n:new_sketch', 'n:new_wall_view', 'n:new_moist_areas', 'n:voice_input', 'n:leak_qty', 'n:new_leak_photo', 'n:meas_photo', 'n:new_damage_report']],
  ['heat', 'detect_heat', ['n:new_heat', 'n:cable_extra']],
  ['roof', 'detect_roof', ['n:new_roof', 'n:new_sketch', 'n:new_moist_areas', 'n:voice_input', 'n:new_damage_report']],
  ['locate', 'detect_locate', ['n:locate_extra', 'n:prax_cable', 'n:stakebull']],
  ['pipe', 'pipe', ['o:18', 'n:pipe_slope', 'n:prax_pipe']],
  ['survey', 'survey', ['n:survey_extra', 'n:rtkengine', 'n:stakebull', 'n:new_ar_stake', 'n:prax_survey']],
  ['garden', 'garden', ['mx:garden', 'n:garden_extra', 'n:prax_garden']],
  ['building', 'building', ['mn:building', 'n:building_scaffold', 'n:prax_building']],
  ['outdoor', 'outdoor', ['mx:outdoor', 'n:outdoor_extra', 'n:prax_outdoor']],
  ['photo', 'photo', ['n:new_photo_branch', 'n:photo_dir', 'n:new_ai_key']],
  ['storm', 'storm', ['n:stormwater', 'n:storm_flood', 'n:storm_river', 'n:storm_report', 'n:stormy']],
];

// main-manual sections that point to the AquaFlow manual (value = AquaFlow chapter number)
const AQ_REF = { 'n:fo_principle': 1, 'n:fo_aquaflow': 1, 'n:fo_workflow': 1, 'n:quick_sync': 2, 'n:cadimport': 2, 'n:teampack': 2, 'n:nettopo': 3, 'n:netquality': 3, 'n:aquaflow': 3, 'n:aqua_ref': 4, 'n:aqua_leakfind': 5, 'mx:press': 5, 'n:logger_round': 6, 'n:offline_navi': 6, 'n:shutoff': 6, 'n:leak_qty': 7, 'n:aqua_leakreport': 8, 'n:new_pc_install': 10, 'n:aqua_hw': 10, 'n:dripx': 11 };
const aqLang = (lang) => AQ[lang] || (lang === 'de' ? AQ.de : AQ.en);

// separate AquaFlow manual (office workstation); sections are own texts or 'n:key' references to the main manual
export function buildAquaManual(lang) {
  const a = aqLang(lang), nl = a === AQ.de ? 'de' : 'en', nw = NEW[nl];
  const chapters = a.ch.map((c, i) => ({
    n: i + 1, icon: c.icon, title: c.title,
    secs: c.secs.map((p) => (typeof p === 'string' ? (({ title, steps, tip }) => ({ title, steps, tip, key: p, imgs: IMGS[p.slice(2)] }))(nw.s[p.slice(2)]) : p)).map((s, k) => ({ ...s, id: `${i + 1}.${k + 1}` })),
  }));
  return { a, lang: nl, chapters };
}

// separate Stormwater manual (all 7 languages, fallback English)
export function buildStormManual(lang) {
  const a = SW[lang] || SW.en, l = SW[lang] ? lang : 'en';
  const chapters = a.ch.map((c, i) => ({ n: i + 1, icon: c.icon, title: c.title, secs: c.secs.map((s, k) => ({ ...s, id: `${i + 1}.${k + 1}` })) }));
  return { a, lang: l, chapters };
}

// separate project management manual (all 7 languages, fallback English); keys 'pm:…' for help links
export function buildPmManual(lang) {
  const a = PMM[lang] || PMM.en, l = PMM[lang] ? lang : 'en';
  const chapters = a.ch.map((c, i) => ({ n: i + 1, icon: c.icon, title: c.title, secs: c.secs.map((s, k) => ({ ...s, key: `pm:${s.key}`, id: `${i + 1}.${k + 1}` })) }));
  return { a, lang: l, chapters };
}

export function buildManual(lang) {
  const m = MANUAL[lang] || MANUAL.de, nw = NEW[lang] || NEW.de, tt = I18N[lang] || I18N.de, x = mtx(lang);
  const part = (p) => {
    const [k, v] = p.split(':');
    if (k === 'o') { const c = m.chapters[+v]; return c && { title: c.title, steps: c.steps, tip: c.tipText, img: c.img }; }
    if (k === 'n') { const c = nw.s[v] || NEW.de.s[v]; return c && { title: c.title, steps: c.steps, tip: c.tip, imgs: IMGS[v], anim: v === 'pc_desk' ? 'pcfolder' : undefined }; }
    if (k === 'mn') { const c = x[`mn_${v}`]; return c && { title: c.title, steps: c.steps, tip: c.tipText }; }
    if (k === 'mx') return tt[`mx_${v}`] && { title: tt[`mx_${v}`], steps: tt[`mx_${v}_s`].split(' | '), tip: tt[`mx_${v}_t`] };
    return x.mg_mode && { title: x.mg_mode.title, steps: x.mg_mode.steps, tip: x.mg_mode.tipText };
  };
  const aq = aqLang(lang);
  const ref = (p) => AQ_REF[p] && { n: AQ_REF[p], title: `${aq.ui.ref}: ${aq.ui.chapter} ${AQ_REF[p]} – ${aq.ch[AQ_REF[p] - 1].title}` };
  const secs = (list, pre) => list.map((p) => { const s = part(p); return s && { ...s, key: p, aq: ref(p) }; }).filter(Boolean).map((s, i) => ({ ...s, id: `${pre}.${i + 1}` }));
  const chapters = PLAN.map(([n, icon, list]) => ({
    n, icon, title: nw.ch[n] || NEW.de.ch[n],
    secs: list ? secs(list, n) : [],
    subs: list ? null : SUBS.map(([k, mode, l], i) => ({ k, mode, title: mode.startsWith('detect') ? `${tt.pf_detect} › ${nw.sub[k] || NEW.de.sub[k]}` : nw.sub[k] || NEW.de.sub[k], secs: secs(l, `14.${i + 1}`) })),
  }));
  return { m, ui: nw.ui, chapters };
}

// all sections of a chapter (incl. sector sub-chapters), optionally filtered to one mode
export const chapterSecs = (c, mode) => (c.subs ? c.subs.filter((s) => !mode || s.mode === mode).flatMap((s) => s.secs) : c.secs);
